import React from 'react';
import ReactDOM from 'react-dom/client';
import './scss/main.scss';
import ReactLenis from '@studio-freight/react-lenis';
import { ToastProvider } from './components/UI/useToast';
import HashScroll from './components/UI/HashScroll';
import HP from './HP';
import { BrowserRouter } from 'react-router-dom';

const host = window.location.host;
const http = window.location.protocol;
let a = host;
if(host.includes('localhost'))  a = '127.0.0.1:8000';
export const STORAGEURL = host.includes('localhost') ? "https://mestecko.agenturagen-preview.cz" : "";
export const APIURL = http+"//"+a+"/api";

export const toURL = (string) => {
  string = string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return string.replace(/[^a-z0-9\s]/gi, '').trim().toLowerCase().replace(/\s+/g, '-');
};


const root = ReactDOM.createRoot(document.body);
root.render(
    <ReactLenis root>
      <BrowserRouter>
        <ToastProvider>
            <HP />
        </ToastProvider>
        <HashScroll mode='location' />
      </BrowserRouter>
    </ReactLenis>
);
